import { Box, Button, Drawer, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "../../../components/Tabs";
import { Search } from "../CargoTemplates/Search";
import { AIRulesForm } from "./AIRulesForm";
import { TemplateBox } from "./TemplateBox";

export const CargoAIDrawer = ({
	handleUseData,
	handleRemove,
	shouldHideDrawer,
	data,
	dataFilter,
}) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);

	const tabs = [
		{
			label: t("add_cargo_ai"),
			content: (
				<Box
					sx={{
						p: "0 30px 30px 30px",
					}}
				>
					<Box
						sx={{
							zIndex: 100,
							position: "sticky",
							top: "49px",
							p: "20px 30px 20px",
							background: "#fff",
						}}
					>
						<Search placeholder={t("search")} onSearch={dataFilter} />
					</Box>
					<Box
						sx={{
							mt: "20px",
							minHeight: "calc(100svh - 200px)",
							height: "100%",
						}}
					>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								gap: "20px",
							}}
						>
							{data.map((cargo) => {
								return (
									<TemplateBox
										key={`ai-cargo-${cargo.id}`}
										data={cargo}
										onClick={handleUseData}
										handleRemove={handleRemove}
									/>
								);
							})}
						</Box>
					</Box>
				</Box>
			),
		},
		{
			label: t("ai_rules"),
			content: (
				<Box sx={{ p: "0 30px 30px 30px", position: "relative" }}>
					<Box
						sx={{
							minHeight: "100svh",
							height: "100%",
							position: "relative",
							marginTop: "20px",
						}}
					>
						<Typography>
							{t("point_values_system_should_use_if_not_found_by_ai")}
						</Typography>
						<Box sx={{ mt: "20px" }}>
							<AIRulesForm />
						</Box>
					</Box>
				</Box>
			),
		},
	];

	return (
		<>
			{shouldHideDrawer && (
				<Button
					variant="contained"
					sx={{
						position: "absolute",
						top: "499px",
						right: "30px",
						textTransform: "uppercase",
					}}
					onClick={() => setIsOpen(true)}
				>
					{t("ai_cargos")}
				</Button>
			)}
			<Drawer
				anchor="right"
				variant={shouldHideDrawer ? "temporary" : "permanent"}
				open={isOpen}
				onClose={() => setIsOpen(false)}
				ModalProps={{
					sx: { zIndex: 999999 },
				}}
			>
				<Box className="ai-drawer-tabs" sx={{ height: "100%", width: "400px" }}>
					<Tabs
						tabs={tabs}
						variant="fullWidth"
						sticky={true}
						TabPanelBoxProps={{ py: 0 }}
					/>
				</Box>
			</Drawer>
		</>
	);
};
